import { type AppLocale } from '@irl/types';

const STORAGE_KEY = 'irl_locale';
const MANUAL_KEY = 'irl_locale_manual';

export function getStoredLocale(): AppLocale | null {
  const value = localStorage.getItem(STORAGE_KEY);
  if (value === 'ru' || value === 'en') {
    return value;
  }
  return null;
}

export function isLocaleManual(): boolean {
  return localStorage.getItem(MANUAL_KEY) === 'true';
}

export function persistLocale(locale: AppLocale, manual = false): void {
  localStorage.setItem(STORAGE_KEY, locale);
  if (manual) {
    localStorage.setItem(MANUAL_KEY, 'true');
  }
}

export function detectLocale(input?: {
  stored?: AppLocale | null;
  telegramLanguageCode?: string | null;
  browserLanguage?: string | null;
}): AppLocale {
  if (input?.stored) {
    return input.stored;
  }

  const telegram = input?.telegramLanguageCode?.toLowerCase() ?? '';
  if (telegram.startsWith('en')) {
    return 'en';
  }

  const browser = input?.browserLanguage?.toLowerCase() ?? '';
  if (browser.startsWith('en')) {
    return 'en';
  }

  return 'ru';
}

export function readTelegramLanguageCode(): string | null {
  const unsafe = (
    window.Telegram?.WebApp as
      | { initDataUnsafe?: { user?: { language_code?: string } } }
      | undefined
  )?.initDataUnsafe?.user?.language_code;
  return unsafe ?? null;
}
